/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const exportpdf = () => import('@/views/move/exportpdf');

const MNG_Arrange001 = () => import('@/views/move/mng_arrange/MNG_Arrange001');
const MNG_Client004 = () => import('@/views/move/mng_client/MNG_Client004');
// const MNG_Client005 = () => import('@/views/move/mng_client/MNG_Client005');
const MNG_Client005_Backup = () => import('@/views/move/mng_client/MNG_Client005_Backup');
const MNG_Client006 = () => import('@/views/move/mng_client/MNG_Client006');
const MNG_Client007 = () => import('@/views/move/mng_client/MNG_Client007');
const MNG_Client008 = () => import('@/views/move/mng_client/MNG_Client008');
const MNG_Client001 = () => import('@/views/move/mng_client/MNG_Client001');
const MNG_Client009 = () => import('@/views/move/mng_client/MNG_Client009');
const MNG_Client010 = () => import('@/views/move/mng_client/MNG_Client010');
// const MNG_Client002 = () => import('@/views/move/mng_client/MNG_Client002');
const MNG_Client003 = () => import('@/views/move/mng_client/MNG_Client003');
const MNG_System001 = () => import('@/views/move/mng_system/MNG_System001');
const MNG_Order001 = () => import('@/views/move/mng_order/MNG_Order001');
const MNG_Order002 = () => import('@/views/move/mng_order/MNG_Order002');
const MNG_Order003 = () => import('@/views/move/mng_order/MNG_Order003');
const MNG_Order004 = () => import('@/views/move/mng_order/MNG_Order004');
const MNG_Order005 = () => import('@/views/move/mng_order/MNG_Order005');
const MNG_Order006 = () => import('@/views/move/mng_order/MNG_Order006');
const MNG_Order008 = () => import('@/views/move/mng_order/MNG_Order008');
const MNG_WorkCheck001 = () => import('@/views/move/mng_workcheck/MNG_WorkCheck001');
const MNG_WorkCheck002 = () => import('@/views/move/mng_workcheck/MNG_WorkCheck002');
const MNG_Contact001 = () => import('@/views/move/mng_contact/MNG_Contact001');
const MNG_System004 = () => import('@/views/move/mng_system/MNG_System004');
const MNG_System005 = () => import('@/views/move/mng_system/MNG_System005');
const MNG_System006 = () => import('@/views/move/mng_system/MNG_System006');
const MNG_Master001 = () => import('@/views/move/mng_master/MNG_Master001');
const MNG_Master002 = () => import('@/views/move/mng_master/MNG_Master002');
const MNG_System002 = () => import('@/views/move/mng_system/MNG_System002');
const MNG_File001 = () => import('@/views/move/mng_file/MNG_File001');
const MNG_File002 = () => import('@/views/move/mng_file/MNG_File002');
const MNG_System002_Detail = () => import('@/views/move/mng_system/MNG_System002_Detail');
const MNG_Master004 = () => import('@/views/move/mng_master/MNG_Master004');
const MNG_Master004_Detail = () => import('@/views/move/mng_master/MNG_Master004_Detail');
const MNG_Master003 = () => import('@/views/move/mng_master/MNG_Master003');
const MNG_Master003_Detail = () => import('@/views/move/mng_master/MNG_Master003_Detail');
const MNG_Master005 = () => import('@/views/move/mng_master/MNG_Master005');
const MNG_Master005_Detail = () => import('@/views/move/mng_master/MNG_Master005_Detail');
const Batch_revert = () => import('@/views/move/batch/Revert');
const MNG_MasterFAQ = () => import('@/views/faq/mng_masterFAQ/LeftComponent');
const MNG_MasterFAQKeyword = () => import('@/views/faq/mng_masterFAQ_keyword/LeftComponent');

const AuthorityManagement = () => import('@/views/move/mng_authority_management/MNG_Authority_Management');
const MNG_Staff001 = () => import('@/views/move/mng_staff/MNG_Staff001');
const MNG_Staff002 = () => import('@/views/move/mng_staff/MNG_Staff002');
const MNG_Schedule001 = () => import('@/views/move/mng_schedule/MNG_Schedule001');
const MNG_Schedule011 = () => import('@/views/move/mng_schedule/MNG_Schedule011');
const MNG_Schedule020 = () => import('@/views/move/mng_schedule/MNG_Schedule020');
const MNG_Accident001 = () => import('@/views/move/mng_accident/MNG_Accident001');
const MNG_Accident004 = () => import('@/views/move/mng_accident/MNG_Accident004');
// const MNG_Accident003 = () =>
//     import('@/views/move/mng_accident/MNG_Accident003');
const MNG_Accident002 = () => import('@/views/move/mng_accident/MNG_Accident002');
const MNG_Accident003 = () => import('@/views/move/mng_accident/MNG_Accident003');
const MNG_Billing001 = () => import('@/views/move/mng_billing/MNG_Billing001');
const MNG_Attendance001 = () => import('@/views/move/mng_attendance/MNG_Attendance001');
const MNG_WorkReport002 = () => import('@/views/move/mng_workreport/MNG_WorkReport002');
const MNG_WorkReport001 = () => import('@/views/move/mng_workreport/MNG_WorkReport001');
const MNG_SalesReport001 = () => import('@/views/move/mng_salesreport/MNG_SalesReport001');
const MNG_SalesReport002 = () => import('@/views/move/mng_salesreport/MNG_SalesReport002');
const MNG_WorkerInfo001 = () => import('@/views/move/mng_worker_info/MNG_WorkerInfo001');
const MNG_WorkerInfo005 = () => import('@/views/move/mng_worker_info/MNG_WorkerInfo005');
const MNG_WorkerInfo002 = () => import('@/views/move/mng_worker_info/MNG_WorkerInfo002');
const MNG_Equipment001 = () => import('@/views/move/mng_equipment/MNG_Equipment001');
const MNG_Equipment003 = () => import('@/views/move/mng_equipment/MNG_Equipment003');
const MNG_Equipment004 = () => import('@/views/move/mng_equipment/MNG_Equipment004');
const MNG_WorkerInfo013 = () => import('@/views/move/mng_worker_info/MNG_WorkerInfo013');
const MNG_AuthorApp001 = () => import('@/views/move/mng_author_app/MNG_AuthorApp001');
const MNG_AuthorApp003_Left = () => import('@/views/move/mng_author_app/MNG_AuthorApp003_Left');
const MNG_AuthorApp002 = () => import('@/views/move/mng_author_app/MNG_AuthorApp002');
const MNG_Schedule002 = () => import('@/views/move/mng_schedule/MNG_Schedule002_Left');
const MNG_WorkerStaff002 = () => import('@/views/move/mng_worker_staff/MNG_WorkerStaff002');
const MNG_WorkerStaff001 = () => import('@/views/move/mng_worker_staff/MNG_WorkerStaff001');
const MNG_Uriage001 = () => import('@/views/move/mng_uriage/MNG_Uriage001');
const MNG_Uriage003 = () => import('@/views/move/mng_uriage/MNG_Uriage003');
const MNG_Uriage002 = () => import('@/views/move/mng_uriage/MNG_Uriage002');

/**
 * Defined Router
 */
export default [
    {
        path: '/MNG_Arrange001',
        name: 'MNG_Arrange001',
        component: MNG_Arrange001,
        meta: {
            title: '見積管理',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client004/:customer_cd?/:branch_cd?',
        name: 'MNG_Client004',
        component: MNG_Client004,
        meta: {
            title: '発注拠点登録',
            layout: 'MainLayout'
        }
    },
    // {
    //     path: '/MNG_Client005',
    //     name: 'MNG_Client005',
    //     component: MNG_Client005,
    //     meta: {
    //         title: '発注担当者一覧',
    //         layout: 'MainLayout'
    //     }
    // },
    {
        path: '/MNG_Client005_Backup',
        name: 'MNG_Client005_Backup',
        component: MNG_Client005_Backup,
        meta: {
            title: '発注担当者一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client006/:id?',
        name: 'MNG_Client006',
        component: MNG_Client006,
        meta: {
            title: '発注担当者登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client007',
        name: 'MNG_Client007',
        component: MNG_Client007,
        meta: {
            title: '社員管理マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client008/:id?',
        name: 'MNG_Client008',
        component: MNG_Client008,
        meta: {
            title: 'ユーザ登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client001',
        name: 'MNG_Client001',
        component: MNG_Client001,
        meta: {
            title: '会社管理',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client009/:customer_cd?/:location_cd?',
        name: 'MNG_Client009',
        component: MNG_Client009,
        meta: {
            title: '新規お客様確認',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client010',
        name: 'MNG_Client010',
        component: MNG_Client010,
        meta: {
            title: '料金表アップロード',
            layout: 'MainLayout'
        }
    },
    // {
    //     path: '/MNG_Client002/:id?',
    //     name: 'MNG_Client002',
    //     component: MNG_Client002,
    //     meta: {
    //         title: 'お客様登録',
    //         layout: 'MainLayout'
    //     }
    // },
    {
        path: '/exportpdf',
        name: 'Exportpdf',
        component: exportpdf,
        meta: {
            title: '業務プログラム',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Client003/:customer_cd?/:location_cd?/:all_branch?',
        name: 'MNG_Client003',
        component: MNG_Client003,
        meta: {
            title: '発注拠点管理',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_System001',
        name: 'MNG_System001',
        component: MNG_System001,
        meta: {
            title: 'TOP',
            layout: 'MainLayout'
        }
    },
    {
        // path: '/MNG_Order001/:customer_cd?/:order_no?',
        path: '/MNG_Order001/:status?',
        name: 'MNG_Order001',
        component: MNG_Order001,
        meta: {
            title: '全受注検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Order002/:id?/:mngStatus1/:mngStatus2?',
        name: 'MNG_Order002',
        component: MNG_Order002,
        meta: {
            title: '受注確認',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Order003',
        name: 'MNG_Order003',
        component: MNG_Order003,
        meta: {
            title: '受注詳細',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Order004/:status?/:customer_cd?/:order_no?',
        name: 'MNG_Order004',
        component: MNG_Order004,
        meta: {
            title: '未処理検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Order005/:status?/:customer_cd?/:order_no?',
        name: 'MNG_Order005',
        component: MNG_Order005,
        meta: {
            title: 'タスク検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Order006/:status?/:customer_cd?/:order_no?',
        name: 'MNG_Order006',
        component: MNG_Order006,
        meta: {
            title: '受注検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Order008/:status?',
        name: 'MNG_Order008',
        component: MNG_Order008,
        meta: {
            title: '見積検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkCheck001',
        name: 'MNG_WorkCheck001',
        component: MNG_WorkCheck001,
        meta: {
            title: '作業日別検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkCheck002',
        name: 'MNG_WorkCheck002',
        component: MNG_WorkCheck002,
        meta: {
            title: '終了確定報告',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Contact001/:status?',
        name: 'MNG_Contact001',
        component: MNG_Contact001,
        meta: {
            title: '確認連絡',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_System004',
        name: 'MNG_System004',
        component: MNG_System004,
        meta: {
            title: 'メッセージ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_System005/:id?',
        name: 'MNG_System005',
        component: MNG_System005,
        meta: {
            title: 'メッセージ送信',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_System006',
        name: 'MNG_System006',
        component: MNG_System006,
        meta: {
            title: '管理者側個人設定',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master001',
        name: 'MNG_Master001',
        component: MNG_Master001,
        meta: {
            title: 'マスタ一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master002',
        name: 'MNG_Master002',
        component: MNG_Master002,
        meta: {
            title: 'マスタ登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_System002',
        name: 'MNG_System002',
        component: MNG_System002,
        meta: {
            title: '料金表一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_File001',
        name: 'MNG_File001',
        component: MNG_File001,
        meta: {
            title: 'ファイルアップロード',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_File002/:id?',
        name: 'MNG_File002',
        component: MNG_File002,
        meta: {
            title: 'ファイルアップロード',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_System002_Detail/:id?/:mode?',
        name: 'MNG_System002_Detail',
        component: MNG_System002_Detail,
        meta: {
            title: '料金表登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master004',
        name: 'MNG_Master004',
        component: MNG_Master004,
        meta: {
            title: '統括部マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master004_Detail/:id?/:mode?',
        name: 'MNG_Master004_Detail',
        component: MNG_Master004_Detail,
        meta: {
            title: '統括部マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master003',
        name: 'MNG_Master003',
        component: MNG_Master003,
        meta: {
            title: '持ち物マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master003_Detail/:id?',
        name: 'MNG_Master003_Detail',
        component: MNG_Master003_Detail,
        meta: {
            title: '持ち物マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master005',
        name: 'MNG_Master005',
        component: MNG_Master005,
        meta: {
            title: '現場担当者マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Master005_Detail/:id?/:mode?',
        name: 'MNG_Master005_Detail',
        component: MNG_Master005_Detail,
        meta: {
            title: '現場担当者マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/batch/manage_reverb/:action',
        name: 'manager_revert',
        component: Batch_revert,
        meta: {
            title: 'batch',
            layout: 'EmptyLayout',
            customeProps: {
                showHeader: false
            }
        }
    },
    {
        path: '/MNG_MasterFAQ',
        name: 'MNG_MasterFAQ',
        component: MNG_MasterFAQ,
        meta: {
            title: '[FAQ]メッセージマスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_MasterFAQKeyword',
        name: 'MNG_MasterFAQKeyword',
        component: MNG_MasterFAQKeyword,
        meta: {
            title: '[FAQ]キーワードマスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Authority_Management',
        name: 'AuthorityManagement',
        component: AuthorityManagement,
        meta: {
            title: '権限管理',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Staff001',
        name: 'MNG_Staff001',
        component: MNG_Staff001,
        meta: {
            title: 'スタッフ情報検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Staff002',
        name: 'MNG_Staff002',
        component: MNG_Staff002,
        meta: {
            title: '紹介者検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Schedule001',
        name: 'MNG_Schedule001',
        component: MNG_Schedule001,
        meta: {
            title: 'スケジュール（月）',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Schedule011',
        name: 'MNG_Schedule011',
        component: MNG_Schedule011,
        meta: {
            title: '設備予約登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Schedule020',
        name: 'MNG_Schedule020',
        component: MNG_Schedule020,
        meta: {
            title: 'スケジュール（スマホ）',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Accident001',
        name: 'MNG_Accident001',
        component: MNG_Accident001,
        meta: {
            title: '事故一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Accident003',
        name: 'MNG_Accident003',
        component: MNG_Accident003,
        meta: {
            title: '事故報告一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Accident004',
        name: 'MNG_Accident004',
        component: MNG_Accident004,
        meta: {
            title: '事故報告共有',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Accident002',
        name: 'MNG_Accident002',
        component: MNG_Accident002,
        meta: {
            title: '事故報告',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Billing001',
        name: 'MNG_Billing001',
        component: MNG_Billing001,
        meta: {
            title: '請求一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Attendance001',
        name: 'MNG_Attendance001',
        component: MNG_Attendance001,
        meta: {
            title: '勤怠登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkReport001',
        name: 'MNG_WorkReport001',
        component: MNG_WorkReport001,
        meta: {
            title: '業務日報一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkReport002',
        name: 'MNG_WorkReport002',
        component: MNG_WorkReport002,
        meta: {
            title: '業務日報一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_AuthorApp002',
        name: 'MNG_AuthorApp002',
        component: MNG_AuthorApp002,
        meta: {
            title: '申請一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_SalesReport001',
        name: 'MNG_SalesReport001',
        component: MNG_SalesReport001,
        meta: {
            title: '営業報告一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_SalesReport002',
        name: 'MNG_SalesReport002',
        component: MNG_SalesReport002,
        meta: {
            title: '営業報告一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkerInfo001',
        name: 'MNG_WorkerInfo001',
        component: MNG_WorkerInfo001,
        meta: {
            title: '受注情報検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkerInfo005',
        name: 'MNG_WorkerInfo005',
        component: MNG_WorkerInfo005,
        meta: {
            title: '「手配」スケジュール検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkerInfo002',
        name: 'MNG_WorkerInfo002',
        component: MNG_WorkerInfo002,
        meta: {
            title: '「手配」受注手配詳細',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Equipment001',
        name: 'MNG_Equipment001',
        component: MNG_Equipment001,
        meta: {
            title: '備品一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Equipment003',
        name: 'MNG_Equipment003',
        component: MNG_Equipment003,
        meta: {
            title: '備品棚卸表',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Equipment004',
        name: 'MNG_Equipment004',
        component: MNG_Equipment004,
        meta: {
            title: '備品カテゴリー',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkerInfo013',
        name: 'MNG_WorkerInfo013',
        component: MNG_WorkerInfo013,
        meta: {
            title: '[手配]受注明細',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_AuthorApp001',
        name: 'MNG_AuthorApp001',
        component: MNG_AuthorApp001,
        meta: {
            title: '承認ルート設定',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_AuthorApp003',
        name: 'MNG_AuthorApp003',
        component: MNG_AuthorApp003_Left,
        meta: {
            title: '承認一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Schedule002',
        name: 'MNG_Schedule002',
        component: MNG_Schedule002,
        meta: {
            title: '承認一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkerStaff002',
        name: 'MNG_WorkerStaff002',
        component: MNG_WorkerStaff002,
        meta: {
            title: '確認スタッフ検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_WorkerStaff001',
        name: 'MNG_WorkerStaff001',
        component: MNG_WorkerStaff001,
        meta: {
            title: '案件サイト申込チェック',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Uriage001',
        name: 'MNG_Uriage001',
        component: MNG_Uriage001,
        meta: {
            title: '締日別請求情報検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Uriage002',
        name: 'MNG_Uriage002',
        component: MNG_Uriage002,
        meta: {
            title: 'エリア別売上検索',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_Uriage003',
        name: 'MNG_Uriage003',
        component: MNG_Uriage003,
        meta: {
            title: '締日別請求情報検索',
            layout: 'MainLayout'
        }
    }
];
